import React from "react";
import { useParams } from "react-router-dom";
import { getDocDataSnap } from "../../Firebase/Firebase.utils";
import { useState, useEffect } from "react";
import LeaseBillingFormComponent from "./LeaseBillingFormComponent";
import BillSupport from "./BillSupport";
import ISBillingFormComponent from "./ISBillingFormComponent";
import {
  FiFileText,
  FiUpload,
  FiCheckCircle,
  FiAlertCircle,
} from "react-icons/fi";
import FinanceStatusUpdateComponent from "./FinanceStatusUpdateComponent";
import { useSelector } from "react-redux";
import ResiLeaseBillingFormComponent from "../Residential/ResiLeaseBillingFormComponent";
import ResearchBilling from "../../Research/ResearchBilling";

function FinanceView() {
  const { id } = useParams();
  const [loading, isLoading] = useState(true);
  const [billingData, setBillingData] = useState({});
  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const fetchBillingData = async () => {
      const data = await getDocDataSnap("billing", id, (res) => {
        setBillingData(res);
        isLoading(false);
      });
    };
    fetchBillingData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#002368]"></div>
      </div>
    );
  }

  if (!billingData) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen text-gray-600">
        <FiAlertCircle className="text-6xl mb-4" />
        <h2 className="text-2xl font-semibold">No Data Found</h2>
        <p className="text-gray-500">
          The requested billing information could not be found.
        </p>
      </div>
    );
  }

  const renderBillingType = () => {
    const commonWrapper = (children) => (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">{children}</div>
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex items-center gap-2 mb-4">
            <FiUpload className="text-[#ff5003] text-xl" />
            <h4 className="text-[#ff5003] font-bold uppercase">
              Step 2: Upload Supporting Documents
            </h4>
          </div>
          <BillSupport id={id} />
        </div>
        <div className="mt-6">
          <FinanceStatusUpdateComponent
            id={id}
            billingData={billingData}
            currentUser={currentUser}
          />
        </div>
      </div>
    );

    switch (billingData.billing_type) {
      case "lease":
        return commonWrapper(
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FiFileText className="text-[#002368] text-xl" />
              <h4 className="text-[#002368] font-bold">
                Commercial Lease Billing
              </h4>
            </div>
            <LeaseBillingFormComponent formData={billingData} disabled={true} />
          </div>
        );

      case "sale":
        return commonWrapper(
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FiFileText className="text-[#002368] text-xl" />
              <h4 className="text-[#002368] font-bold">
                Sale Transaction Billing
              </h4>
            </div>
            <ISBillingFormComponent formData={billingData} disabled={true} />
          </div>
        );

      case "residentialLease":
        return commonWrapper(
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FiFileText className="text-[#002368] text-xl" />
              <h4 className="text-[#002368] font-bold">
                Residential Lease Billing
              </h4>
            </div>
            <ResiLeaseBillingFormComponent
              formData={billingData}
              disabled={true}
            />
          </div>
        );

      case "research":
        return commonWrapper(
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FiFileText className="text-[#002368] text-xl" />
              <h4 className="text-[#002368] font-bold">Research Billing</h4>
            </div>
            <ResearchBilling data={billingData} disabled={true} />
          </div>
        );

      default:
        return (
          <div className="flex flex-col items-center justify-center min-h-screen text-gray-600">
            <FiAlertCircle className="text-6xl mb-4" />
            <h2 className="text-2xl font-semibold">Invalid Billing Type</h2>
            <p className="text-gray-500">The billing type is not recognized.</p>
          </div>
        );
    }
  };

  return renderBillingType();
}

export default FinanceView;
